import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AttributeDeleteNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M4.27266 1.72734L1.72736 4.27264L19.7273 22.2726L22.2726 19.7273L4.27266 1.72734Z"
        fill={color}
      />
      <path
        d="M19.7273 1.72739L1.72736 19.7274L4.27266 22.2727L22.2726 4.27269L19.7273 1.72739Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AttributeDeleteNsk.displayName = 'AttributeDeleteNsk';
